import { ContainerModule, WebuiIocKey } from '@ztechapps/webui.contract'
import { ContactSelect } from './ContactSelect/ContactSelect'
import { CustomerSelect } from './CustomerSelect/CustomerSelect'
import { CustomerSelectCreatable } from './CustomerSelect/CustomerSelectCreatable'
import { CustomerAddress } from './CustomerAddress'
import { CustomerWidget } from './CustomerWidget'
import { CustomerInfoForm } from './CustomerInfoForm/CustomerInfoForm'

export const customerContainer = new ContainerModule((bind) => {
  bind(WebuiIocKey.customer.customerSelect).to(CustomerSelect)
  bind(WebuiIocKey.customer.customerSelectCreatable).to(CustomerSelectCreatable)
  bind(WebuiIocKey.customer.customerAddress).to(CustomerAddress)
  bind(WebuiIocKey.customer.customerWidget).to(CustomerWidget)
  bind(WebuiIocKey.customer.customerInfoForm).to(CustomerInfoForm)
  bind(WebuiIocKey.customer.contactSelect).to(ContactSelect)
})
